export class DashboardItem {
    title: string;
    iconUrl: string;
    ref: string
}